import { render, staticRenderFns } from "./BookusLogo.vue?vue&type=template&id=63bed8f4&"
import script from "./BookusLogo.vue?vue&type=script&lang=js&"
export * from "./BookusLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports